<template>
      <div class="">
        <div class="row" v-if="isCompanyAdmin == 1">
          <div class="col-sm-12 col-md-12 breadcrumb-side-button">
            <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
              <el-tooltip
                placement="top"
                :effect="themeMode.darkMode == true ? 'light' : 'dark'"
                :content="$t('create_action')">
                  <button
                    type="button"
                    class="btn btn-primary btn-with-shadow"
                    data-toggle="modal"
                    @click="openJobCreateModal('job-template')">
                    {{ $t("create_from_template") }}
                  </button>
              </el-tooltip>
              <el-tooltip
                placement="top"
                :effect="themeMode.darkMode == true ? 'light' : 'dark'"
                :content="$t('create_action')">
                  <button
                    type="button"
                    class="btn btn-primary btn-with-shadow"
                    data-toggle="modal"
                    @click="openJobCreateModal">
                    {{ $t("create_job") }}
                  </button>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div v-if="this.active != 1">
          <el-tooltip
            placement="top"
            :effect="themeMode.darkMode == true ? 'light' : 'dark'"
            :content="$t('certifications')">
              <button
              type="button"
              class="btn btn-sm btn-primary el-button--default"
              v-if="this.active < 6"
              @click="previous"
              style="float: right"
            >
              <span>Previous</span>
            </button>
          </el-tooltip>
        </div>
        <el-form v-if="active === 1">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div
                    class="p-primary align-items-center primary-card-color border-bottom"
                    >
                    <ul
                        class="nav tab-filter-menu d-inline-flex justify-content-flex-end"
                    >
                        <li
                        class="nav-item"
                        v-for="(item, index) in userFilterOptions"
                        :key="index"
                        >
                        <a
                            href="#"
                            class="nav-link font-size-default py-0"
                            :class="[
                            filteredData.status == item.id
                                ? 'active'
                                : index === 0 && filteredData.status === 'not-job-template'
                                ? 'active'
                                : '',
                            ]"
                            @click.prevent="getFilterValue(item.id)"
                        >
                            {{ item.value }}
                        </a>
                        </li>
                    </ul>
                    <div class="float-right">
                        <app-search @input="getSearchValue" />
                    </div>
                    </div>
                </div>
            </div>
            <app-table
                :id="tableId"
                :options="options"
                :search="search"
                :card-view="false"
                @action="getListAction"
                :filtered-data="filteredData"
                />
        </el-form>
        <el-form v-if="active === 2">
            <job-management :id="job_id" :active="{ active }"/>
        </el-form>

        <job-create-modal
          v-if="jobCreateModalActive"
          :companyId="companyId"
          :isJobTemplate="isJobTemplate"
          @close-modal="closeJobCreateModal"
        />

      </div>
</template>


<script>
import CoreLibrary from "../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../Config/ApiUrl";
import { TableHelpers } from "../Demo/Tables/mixins/TableHelpers";
import { axiosGet } from "../../../Helpers/AxiosHelper";

export default {
  extends: CoreLibrary,
  name: "tab-filter",
  mixins: [TableHelpers],
  props: {
    customerCompanyId: Number,
    sectionTitle: String,
  },
  data() {
    return {
      // isAddEditModalActive: false,
      companyId: this.$attrs['props'].companyId,
      jobCreateModalActive: false,
      active: 1,
      job_id: 0,
      instructionShow: false,
      check: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      filteredData: {
        status: "not-job-template",
      },
      search: "",
      tableId: "job-list",
      rowData: {},
      options: {
        // cardView: true,
        // cardViewComponent: "grid-view",
        name: this.$t("tab_filter"),
        url: this.getActionUrl(),
        datatableWrapper: false,
        tableShadow: false,
        showHeader: true,
        columns: [
          {
            title: this.setSectionTitle(),
            type: "custom-html",
            key: "title",
            isVisible: true,
            modifier: (value,row) => {
              return `<a href="#" id="${row.id}" @click=${this.myFunction(row.id)}>${this.$t(value)}</a>`;
            },
          },
          {
            title: this.$t("start_date"),
            type: "custom-html",
            key: "start_date",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("end_date"),
            type: "custom-html",
            key: "end_date",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("is_private"),
            type: "custom-html",
            key: "is_private",
            modifier: (value) => {
              let type = 'Private';

              if (value == 0) {
                type = 'Public';
              }
              return `<span>${this.$t(type)}</span>`;
            },
          },
          {
            title: this.$t("type"),
            type: "custom-html",
            key: "job_type",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            isVisible: true,
            modifier: (value, row) => {
              let ClassName = "warning";


              const date1 = new Date(row.end_date);
              const date2 = new Date();
              // One day in milliseconds
              const oneDay = 1000 * 60 * 60 * 24;
              // Calculating the time difference between two dates
              const diffInTime = date1.getTime() - date2.getTime();
              // Calculating the no. of days between two dates
              const diffInDays = Math.round(diffInTime / oneDay);

              if (value === "active") ClassName = `success`;
              else if (value === "inprogress") ClassName = `dark`;
              else if (value === "completed") ClassName = `primary`;
              else if (diffInDays <= 0) {ClassName = `danger`};


              let statusValue = diffInDays <= 0? 'Due' : value;
              let StatusClass = diffInDays <= 0? 'danger' :ClassName;
              if (value == 'job-template') {
                  statusValue = value;
                  StatusClass = `warning`;
              }

              return `<span class="text-capitalize badge badge-sm badge-pill badge-${StatusClass}">${this.$t(
                  statusValue
              )}</span>`;
            },
          },
          {
              title: this.$t('bid_counts'),
              type: 'custom-html',
              key: 'assigned_bid_form',
              modifier: (value) => {
                let count = value.length > 0 ? value[0].accepted_forms.length :'Bidform not assign';

                  return `<span>`+count+`</span>`
              }
          },
          {
            title: this.$t("created_at"),
            type: "custom-html",
            key: "created_at",
            modifier: (value) => {
              var date = moment(value).format("YYYY-MM-DD hh:mm");
              return `<span>${this.$t(date)}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
          },
        ],
        showFilter: false,
        // showSearch: true,
        showCount: true,
        // showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
        isJobTemplate: false,
      },
      userFilterOptions: [
        { id: "not-job-template", value: "All Jobs" },
        { id: "active", value: "Active" },
        { id: "inprogress", value: "Inprogress" },
        { id: "draft", value: "Draft" },
        { id: "completed", value: "Completed" },
        { id: "job-template", value: "Template" },
      ],
    };
  },

  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  mounted(){
    let urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has('status') == true) {
        let status = urlParams.get('status');
        this.getFilterValue(status);
    }
    setTimeout(() => {
      this.customerAction();
    }, 5000);
  },
  methods: {
    setManagementTitle(){
      let title = this.sectionTitle?'Contract Management':'job_management';
      return this.$t(title);
    },
    setSectionTitle(){
      let title = this.sectionTitle??'jobs';
      return this.$t(title);
    },
    getSearchValue(value) {
      let instance = this;
      this.search = value;
      setTimeout(function () {
        instance.$hub.$emit("reload-" + instance.tableId);
      });
    },
    getFilterValue(item) {
      this.filteredData.status = item;

      this.$hub.$emit("reload-" + this.tableId);
    },

    myFunction(id){
      let doc = document.getElementById(id);
      if(doc){
        doc.addEventListener('click', () => {
          this.view(id)
        }) 
      }
    },
    view(id) {
        this.job_id = id;
        this.active = 2
    },

    getListAction(rowData, actionObj, active) {
      if (actionObj.title == this.$t("view")) {
        this.view(rowData.id);
      } 
    },
    searchAndSelectFilterOptions() {
      this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select")
        );
        name.option = response.data.map((name) => {
          return {
            id: name.name,
            value: name.name,
          };
        });
      });
    },
    getActionUrl() {
      let customerCompanyId = this.customerCompanyId;
      let url = actions.COMPANY_JOBS
      if(customerCompanyId){
        url = actions.COMPANY_JOBS + '/' + this.customerCompanyId
      }
      let company_Id = !this.$attrs['props'].companyId ? '' : '?company_id='+ this.$attrs['props'].companyId;
      return url + company_Id;
    },
    customerAction() {
      let role = this.userRole.role;
      console.log(role);
      if (role == "Customer" || role == "customer") {
        this.options.actions = [
        {
            title: this.setManagementTitle(),
            icon: "clipboard",
            type: "none",
          },
      ]
      }
    },
    previous() {
        this.active = 1;
    },
    openJobCreateModal(type = null) {
      if(type == 'job-template') {
        this.isJobTemplate = true;
      }
      this.jobCreateModalActive = true;
    },
    closeJobCreateModal() {
      $("#job-create-modal").modal("hide");
      this.jobCreateModalActive = false;
      this.$hub.$emit("reload-" + this.tableId);

    }
  },
  computed: {
    themeMode() {
      return this.$store.state.theme;
    },
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
    isCompanyAdmin() {
      return this.$store.state.user.loggedInUser.is_company_admin;
    },
  },

};
</script>
